// --- 游泳馆管理 --- //

export default [
  {
    name: 'swimmingManagement',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/swimmingManagement',
    meta: { title: '游泳馆管理' },
    component: require('business/stadiumSuperviseSystem/swimmingSuperviseStadium/list.vue').default
  },
  {
    name: 'swimmingDetail',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/swimmingManagement/detail',
    meta: { title: '场馆详情' },
    component: require('business/stadiumSuperviseSystem/swimmingSuperviseStadium/detail.vue').default
  }
];
